module.exports = __webpack_public_path__ + "img/1538538000.769a866e.jpg";